import { Controller } from "@hotwired/stimulus"

// SNS分析エージェントの設定画面「分析対象」の箱(連携アカウント / キーワード)1つ分の絞り込み
// (app/views/agent_detection_settings/_analysis_section.html.erb)。
// 名前の絞り込み(input)と「外したものだけ」(excludedToggle、aria-pressed)を組み合わせて行を出し分ける。
// 行の出し分けは search_controller と同じく style.display で行い、行には data-search-target="row" を残す
// (check_all_controller の visibleItems が表示中の行だけを一括チェックの対象にするため)。
// 「外したものだけ」でチェックを付け直した行は、次の filter で表示から消える
// 「外したものだけ」を押したときの見た目。押していないときは btn-outline(view の初期の class)。
// daisyUI 5 の .btn:is([aria-pressed=true]) は --btn-bg を「btn-color(btn-primary なら primary)に黒を 5% 混ぜた色」に置き換えるため、
// btn-soft の淡い背景は効かず、濃い青の背景に青い文字が乗って読めなくなる(実測 1.52:1)。
// そこで背景・枠・文字色を ! で固定する(.btn の background-color / border-color / color はどれも !important ではないので、こちらが勝つ)。
// light は blue-50 の背景に blue-700 の文字、dark は blue-950 の背景に blue-300 の文字(どちらも 4.5:1 以上)。
// Tailwind はこのファイルも走査するので、クラス名はここに文字列で書く
export const EXCLUDED_PRESSED_CLASSES = [
  "btn-primary", "bg-blue-50!", "border-primary!", "text-blue-700!",
  "in-data-[theme=dark]:bg-blue-950!", "in-data-[theme=dark]:text-blue-300!",
]
export const EXCLUDED_UNPRESSED_CLASSES = ["btn-outline"]

export default class extends Controller {
  static targets = ["input", "row", "empty", "excludedToggle", "excludedCount", "visibleCount"]

  connect() {
    this.filter()
  }

  filter() {
    const query = this.hasInputTarget ? this.inputTarget.value.toLowerCase().trim() : ""
    const excludedOnly = this.excludedOnly()
    let visible = 0
    let excluded = 0

    this.rowTargets.forEach((row) => {
      const unchecked = !this.checkboxOf(row).checked
      if (unchecked) excluded++

      const name = (row.dataset.accountName || "").toLowerCase()
      const matches = (query === "" || name.includes(query)) && (!excludedOnly || unchecked)
      row.style.display = matches ? "" : "none"
      if (matches) visible++
    })

    if (this.hasExcludedCountTarget) this.excludedCountTarget.textContent = String(excluded)
    if (this.hasVisibleCountTarget) this.visibleCountTarget.textContent = String(visible)
    // 「該当なし」は、絞り込んだ結果が0件のときだけ出す
    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible > 0 || (query === "" && !excludedOnly))
  }

  toggleExcluded() {
    if (!this.hasExcludedToggleTarget) return

    const pressed = !this.excludedOnly()
    const toggle = this.excludedToggleTarget
    toggle.setAttribute("aria-pressed", String(pressed))
    EXCLUDED_PRESSED_CLASSES.forEach((name) => toggle.classList.toggle(name, pressed))
    EXCLUDED_UNPRESSED_CLASSES.forEach((name) => toggle.classList.toggle(name, !pressed))
    this.filter()
  }

  excludedOnly() {
    return this.hasExcludedToggleTarget && this.excludedToggleTarget.getAttribute("aria-pressed") === "true"
  }

  checkboxOf(row) {
    return row.querySelector('input[type="checkbox"]')
  }
}
